import { EmployeeRestaurant } from '@/contexts/user-context';
import { RestaurantEmployeeFragment } from '@/types';
import { RestaurantEmployeeList } from '@/components/restaurant/restaurant-employee-list';
import { SCREEN_PADDING, SCREEN_PADDING_XS } from '@/styles';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { UnknownContactInfo } from './types';
import { useRestaurantEmployees } from '@/hooks/use-restaurant-employees';

interface SelectEmployeeProps {
  contactInfo: UnknownContactInfo;
  employeeItemStyle?: StyleProp<ViewStyle>;
  hasItemDivider?: boolean;
  hideAddNew?: boolean;
  hideUpdateEmployees?: boolean;
  isEmployeeSelectable?: (employee?: RestaurantEmployeeFragment) => boolean;
  onAddNew?: () => void;
  onComplete?: (employeeId: string) => void;
  onSelect: (employee: RestaurantEmployeeFragment) => void;
  restaurantRelationship: EmployeeRestaurant;
  scrollEnabled?: boolean;
  selectedEmployeeItemStyle?: StyleProp<ViewStyle>;
  selectedRestaurantEmployeeUUID?: string;
  style?: StyleProp<ViewStyle>;
}

export const SelectEmployeeList: React.FC<SelectEmployeeProps> = ({
  contactInfo,
  employeeItemStyle,
  hasItemDivider = true,
  hideAddNew = false,
  hideUpdateEmployees = false,
  isEmployeeSelectable,
  onAddNew,
  onComplete,
  onSelect,
  restaurantRelationship,
  scrollEnabled = true,
  selectedEmployeeItemStyle,
  selectedRestaurantEmployeeUUID,
  style,
}) => {
  const { restaurantEmployees, loading } = useRestaurantEmployees(
    restaurantRelationship.uuid,
    restaurantRelationship.supplierUUID,
  );

  return (
    <RestaurantEmployeeList
      addNewItemStyle={styles.addNewItem}
      emailAddress={contactInfo.emailAddress}
      employeeItemStyle={[styles.employeeItem, employeeItemStyle]}
      hasItemDivider={hasItemDivider}
      hideAddNew={hideAddNew}
      hideUpdateEmployees={hideUpdateEmployees}
      isEmployeeSelectable={isEmployeeSelectable}
      itemDividerStyle={styles.itemDivider}
      loading={loading}
      onAddNew={onAddNew}
      onComplete={onComplete}
      onEmployeeSelect={onSelect}
      phoneNumber={contactInfo.phoneNumber}
      restaurantEmployees={restaurantEmployees}
      restaurantRelationship={restaurantRelationship}
      scrollEnabled={scrollEnabled}
      selectedEmployeeItemStyle={selectedEmployeeItemStyle}
      selectedRestaurantEmployeeUUID={selectedRestaurantEmployeeUUID}
      style={[styles.employeeList, style]}
    />
  );
};

const styles = StyleSheet.create({
  addNewItem: {
    marginHorizontal: SCREEN_PADDING_XS,
    paddingHorizontal: 0,
  },
  employeeItem: {
    marginHorizontal: SCREEN_PADDING,
    paddingHorizontal: 0,
  },
  employeeList: {
    paddingBottom: SCREEN_PADDING,
  },
  itemDivider: {
    marginHorizontal: SCREEN_PADDING,
  },
});
